import { useEffect } from "react"

const LeadBoxesScript = ({ id }) => {
  useEffect(() => {
    const handleLeadboxesReady = () => {
      if (window.LPLeadboxes) {
        window.LPLeadboxes.setExitIntent(id, {
          dontShowFor: "0d",
          domain: "clearout.lpages.co",
        })
      }
    }

    // Check if the script already exists
    const existingScript = document.querySelector(
      'script[src="https://embed.lpcontent.net/leadboxes/current/embed.js"]'
    )

    if (existingScript) {
      // If script is already loaded and LPLeadboxes is available
      if (window.LPLeadboxes) {
        handleLeadboxesReady()
      } else {
        window.addEventListener("LPLeadboxesReady", handleLeadboxesReady)
      }
    } else {
      // If script is not yet added, add it
      const script = document.createElement("script")
      script.src = "https://embed.lpcontent.net/leadboxes/current/embed.js"
      script.async = true
      script.defer = true
      document.body.appendChild(script)

      script.addEventListener("load", () => {
        window.addEventListener("LPLeadboxesReady", handleLeadboxesReady)
      })
    }

    return () => {
      window.removeEventListener("LPLeadboxesReady", handleLeadboxesReady)
    }
  }, [id])

  return null
}

export default LeadBoxesScript
